import React from "react";
import Contact from "@/model/interface/Contact";

interface ContactStatePillProps {
  contact?: Contact | null;
}

const ContactStatePill: React.FC<ContactStatePillProps> = ({ contact }) => {
  if (!contact?.deletedAt) {
    return null;
  }
  return <span className="status-pill-neutral">Archived</span>;
};

export default ContactStatePill;
